export var BroadcastType;
(function (BroadcastType) {
    BroadcastType["to_all"] = "to_all";
    BroadcastType["by_segment"] = "by_segment";
})(BroadcastType || (BroadcastType = {}));
